// SAL6010_R01 검색 섹션
// - 회사/기간/거래처/견적번호 등 조회 필터 입력 및 코드검색 모달 연계
import { ChangeEvent, useCallback, useState } from "react";
import { getCustomerList } from "src/apis/customerApi";


import useUiuxStore from "src/store/useUiuxStore";
import { defaultSAL6010_R01Filter, useSAL6010_R01Store } from "src/containers/mes/SAL/SAL6010_R01/Store_SAL6010_R01";

import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

interface Props {
}

export const SearchSection_SAL6010_R01 = (props: Props) => {
	const { SAL6010_R01Filter, setSAL6010_R01Filter } = useSAL6010_R01Store();

    const { codeSearchModalVisible, setCodeSearchModalProps } = useUiuxStore();
    
	const { compCdList, customCdList } = useCommonCodeStore();

    const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const custInfoHandleFoucsId = 'infoCustInput_search';

    const handleFilterCompanyChange = (selectedValue: string) => {
        setSAL6010_R01Filter({ compCd: selectedValue });
    }

    // 견적번호 입력
    const handleSalesEstimateNoChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSAL6010_R01Filter({ salesEstimateNo: e.target.value });
    }

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'custInput',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'custInput',
				customNm: 'custNm',
			},
			extraFilter: () => ({
				compCd: SAL6010_R01Filter.compCd || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: SAL6010_R01Filter,
		setEditData: setSAL6010_R01Filter,
		defaultData: defaultSAL6010_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'SAL6010_R01_search'
	});

    return (
		<>
		<SearchSectionForm>
			{/* 회사 선택 */}
			<SearchDropDownForm
				label="회사"
				value={SAL6010_R01Filter.compCd}
				optionList={compCdList}
				onChangeValue={handleFilterCompanyChange}
			/>
			{/* 견적번호 입력 */}
			
			<SearchDateRangeForm
				label="매출 조회 기간"
				wrapperOption={{
					titleStyle: 'h-[24px] flex items-center truncate shrink-0 w-[80px] min-w-[80px]',
				}}
				visible={pickerVisible}
				setVisible={setPickerVisible}
				dateRange={SAL6010_R01Filter.dateRange}
				setDateRange={(dateRange) => setSAL6010_R01Filter({ 
					dateRange: dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			{/* 거래처 검색 */}
			<SearchCodeModalForm
				label="거래처"
				value={SAL6010_R01Filter.custInput}
				valueLabel={SAL6010_R01Filter.custNm}
				handleFoucsId={custInfoHandleFoucsId}
				onChange={getFieldHandlers('custInput').onChange}
				onDoubleClick={getFieldHandlers('custInput').onDoubleClick}
				onKeyDown={getFieldHandlers('custInput').onEnterKeyDown}
			/>
			<SearchInputForm
				label="견적번호"
				value={SAL6010_R01Filter.salesEstimateNo}
				onChange={handleSalesEstimateNoChange}
			/>
		</SearchSectionForm>
		{/* searchedCustomer : {JSON.stringify(searchedCustomer)} */}
		</>
	)
}

export default SearchSection_SAL6010_R01;
